import LocalStorageService from '@/service/LocalStorage';

export const clearAdminFilters = (filters: string) => {
  return LocalStorageService.delete(filters);
};
